import { render, staticRenderFns } from "./Root.vue?vue&type=template&id=9e59d808"
import script from "./Root.vue?vue&type=script&lang=js"
export * from "./Root.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports